import React, { useState } from 'react';
import { Eye, EyeOff, CheckCircle, AlertCircle } from 'lucide-react';
import './Input.css';

const Input = ({ 
  label, 
  value, 
  onChange, 
  placeholder, 
  type = 'text', 
  required = false, 
  hint,
  error,
  success,
  icon: Icon,
  disabled = false,
  className = '',
  size = 'md',
  variant = 'default',
  ...props 
}) => {
  const [showPassword, setShowPassword] = useState(false);
  const [focused, setFocused] = useState(false);
  const isPassword = type === 'password';
  const inputType = isPassword ? (showPassword ? 'text' : 'password') : type;

  const sizes = {
    sm: 'px-3 py-1.5 text-sm',
    md: 'px-4 py-2.5 text-sm',
    lg: 'px-5 py-3.5 text-base'
  };

  const variants = {
    default: '',
    filled: 'bg-[#F8FAFC] border-[#E2E8F0] focus:bg-white',
    outline: 'bg-transparent border-2',
    glass: 'bg-white/10 backdrop-blur-xl border-white/20 text-white placeholder-white/50'
  };

  const statusIcon = error ? <AlertCircle className="input-status-icon error" /> :
                    success ? <CheckCircle className="input-status-icon success" /> : null;

  return (
    <div className={`input-group ${className}`}>
      {label && (
        <label className="input-label">
          {label}
          {required && <span className="input-required">*</span>}
        </label>
      )}
      <div className={`input-wrapper ${focused ? 'focused' : ''} ${error ? 'has-error' : ''} ${success ? 'has-success' : ''}`}>
        {Icon && <Icon className="input-icon" />}
        <input
          type={inputType}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          required={required}
          disabled={disabled}
          onFocus={() => setFocused(true)}
          onBlur={() => setFocused(false)}
          className={`input-field ${Icon ? 'with-icon' : ''} ${isPassword ? 'with-password' : ''} ${sizes[size]} ${variants[variant]}`}
          {...props}
        />
        {isPassword && (
          <button
            type="button"
            className="input-password-toggle"
            onClick={() => setShowPassword(!showPassword)}
          >
            {showPassword ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
          </button>
        )}
        {statusIcon}
      </div>
      <div className="input-footer">
        {hint && <p className="input-hint">{hint}</p>}
        {error && <p className="input-error-text">{error}</p>}
      </div>
    </div>
  );
};

export default Input;